import { render, staticRenderFns } from "./onboarding-modal.vue?vue&type=template&id=11c3230b&scoped=true"
import script from "./onboarding-modal.vue?vue&type=script&lang=js"
export * from "./onboarding-modal.vue?vue&type=script&lang=js"
import style0 from "./onboarding-modal.vue?vue&type=style&index=0&id=11c3230b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c3230b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11c3230b')) {
      api.createRecord('11c3230b', component.options)
    } else {
      api.reload('11c3230b', component.options)
    }
    module.hot.accept("./onboarding-modal.vue?vue&type=template&id=11c3230b&scoped=true", function () {
      api.rerender('11c3230b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding-modal.vue"
export default component.exports